<div class="modal-header-bar">
  <div class="modal-bar-title" translate>contactUsTitle</div>
  <div class="close-modal" (click)="dismiss()" translate>closeBtnTitle</div>
</div>
<div class="contact-info">
  <h2>Medplus Solutions</h2>
  <p>282 AVE JESUS T PINERO STE 202</p>
  <p>SAN JUAN PR 00927-3916</p>

  <h3 translate>customerServiceTitle</h3>
  <p>Tel. <a href="tel:7875232900">787.523.2900</a></p>

  <h3>{{'medlinkHelpLinkTitle' | translate}}:</h3>

  <div class="external-link" (click)="openUrl()">
    https://www.medpluspr.com/contactus
  </div>
</div>